import zappy from '@zappy-ride/library.react.components';
import { OutputIncentives } from './Incentives';

export * from './Incentives';

zappy.FactoryInstance.registerComponent(OutputIncentives);
